/* Sofa Cocoon — script du thème : menu, panier (tiroir), fiche produit, galerie, carrousel d'avis, filtres. Sans dépendance. */
(function () {
  'use strict';

  var cfg = window.cocoon || {};
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var onCartPage = document.body.getAttribute('data-template') === 'cart';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function closest(el, sel) { return el && el.closest ? el.closest(sel) : null; }

  /* ------------------------------------------------------------------
     Menu mobile
  ------------------------------------------------------------------ */
  function setMenu(open) {
    var menu = $('#MobileMenu');
    if (!menu) return;
    menu.hidden = !open;
    var btn = $('[data-menu-open]');
    if (btn) btn.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) {
      var c = $('[data-menu-close]', menu);
      if (c) c.focus();
    }
  }

  /* ------------------------------------------------------------------
     Panier : tiroir
  ------------------------------------------------------------------ */
  var lastFocus = null;

  function drawer() { return $('#CartDrawer'); }
  function overlay() { return $('[data-cart-overlay]'); }
  function drawerIsOpen() { var d = drawer(); return !!(d && d.classList.contains('open')); }

  function openCart() {
    var d = drawer();
    if (!d) return false;
    lastFocus = document.activeElement;
    var o = overlay();
    if (o) o.hidden = false;
    d.classList.add('open');
    document.body.style.overflow = 'hidden';
    window.setTimeout(function () {
      var c = $('[data-cart-close]', d);
      if (c) c.focus();
    }, 60);
    return true;
  }

  function closeCart() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('open');
    var o = overlay();
    if (o) o.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-zero', Number(n) === 0);
    });
  }

  function showCartError(message) {
    var el = $('[data-cart-error]');
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
  }

  function applyDrawerHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('#CartDrawer');
    var d = drawer();
    if (!fresh || !d) return;
    d.innerHTML = fresh.innerHTML;
    var count = Number(fresh.getAttribute('data-count')) || 0;
    d.setAttribute('data-count', String(count));
    setCount(count);
    if (drawerIsOpen() && (document.activeElement === document.body || !document.activeElement)) {
      var c = $('[data-cart-close]', d);
      if (c) c.focus();
    }
  }

  function jsonHeaders() {
    return { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  }

  function parse(response) {
    return response.json().then(function (data) {
      return { ok: response.ok, status: response.status, data: data };
    });
  }

  function errorMessage(res) {
    var d = res && res.data ? res.data : {};
    return d.description || d.message || 'Une erreur est survenue. Réessayez dans un instant.';
  }

  function refreshCart() {
    return fetch((cfg.rootUrl || '/') + '?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (sections && sections['cart-drawer']) applyDrawerHtml(sections['cart-drawer']);
      })
      .catch(function () { /* silencieux : l'affichage reste celui de la page */ });
  }

  function addToCart(variantId, quantity) {
    var body = {
      items: [{ id: Number(variantId), quantity: quantity || 1 }],
      sections: 'cart-drawer',
      sections_url: window.location.pathname
    };
    return fetch(cfg.cartAddUrl + '.js', { method: 'POST', headers: jsonHeaders(), body: JSON.stringify(body) })
      .then(parse)
      .then(function (res) {
        if (!res.ok || res.data.status) throw new Error(errorMessage(res));
        return res.data;
      });
  }

  function afterAdd(data) {
    var html = data && data.sections && data.sections['cart-drawer'];
    if (onCartPage || !cfg.drawer || !drawer()) {
      window.location.href = cfg.cartUrl;
      return;
    }
    if (html) applyDrawerHtml(html);
    else refreshCart();
    showCartError('');
    openCart();
  }

  function changeLine(line, quantity) {
    var d = drawer();
    if (d) d.classList.add('is-busy');
    var body = {
      line: Number(line),
      quantity: Number(quantity),
      sections: 'cart-drawer',
      sections_url: window.location.pathname
    };
    return fetch(cfg.cartChangeUrl + '.js', { method: 'POST', headers: jsonHeaders(), body: JSON.stringify(body) })
      .then(parse)
      .then(function (res) {
        if (!res.ok || res.data.status) throw new Error(errorMessage(res));
        var html = res.data.sections && res.data.sections['cart-drawer'];
        if (html) applyDrawerHtml(html);
        else return refreshCart();
      })
      .catch(function (err) { showCartError(err.message); })
      .then(function () {
        var dd = drawer();
        if (dd) dd.classList.remove('is-busy');
      });
  }

  /* ------------------------------------------------------------------
     Clics et touches (délégation : fonctionne aussi après un rechargement
     de section dans l'éditeur de thème)
  ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var t = e.target;

    if (closest(t, '[data-menu-open]')) { setMenu(true); return; }
    if (closest(t, '[data-menu-close]')) {
      setMenu(false);
      var mb = $('[data-menu-open]');
      if (mb) mb.focus();
      return;
    }
    if (closest(t, '#MobileMenu a')) { setMenu(false); return; }

    if (closest(t, '[data-cart-close]') || t === overlay()) { closeCart(); return; }

    var opener = closest(t, '[data-cart-open]');
    if (opener && !onCartPage && cfg.drawer && drawer()) {
      e.preventDefault();
      showCartError('');
      openCart();
      refreshCart();
      return;
    }

    var lineBtn = closest(t, '[data-line]');
    if (lineBtn && closest(lineBtn, '#CartDrawer')) {
      showCartError('');
      changeLine(lineBtn.getAttribute('data-line'), lineBtn.getAttribute('data-quantity'));
      return;
    }

    var quick = closest(t, '[data-add-to-cart]');
    if (quick) {
      e.preventDefault();
      if (quick.disabled || quick.classList.contains('loading')) return;
      quick.classList.add('loading');
      addToCart(quick.getAttribute('data-variant-id'), 1)
        .then(afterAdd)
        .catch(function (err) {
          if (drawer() && cfg.drawer) { openCart(); showCartError(err.message); }
          else window.alert(err.message);
        })
        .then(function () { quick.classList.remove('loading'); });
      return;
    }

    var sticky = closest(t, '[data-sticky-btn]');
    if (sticky) {
      var sec = closest(sticky, '[data-product-section]');
      var form = sec && $('[data-product-form]', sec);
      if (form) {
        if (form.requestSubmit) form.requestSubmit($('[data-add-button]', form));
        else $('[data-add-button]', form).click();
      }
      return;
    }

    var ft = closest(t, '[data-filters-toggle]');
    if (ft) {
      var panel = $('[data-filters-panel]');
      if (panel) {
        var open = !panel.classList.contains('is-open');
        panel.classList.toggle('is-open', open);
        ft.setAttribute('aria-expanded', String(open));
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (drawerIsOpen()) { closeCart(); return; }
      var menu = $('#MobileMenu');
      if (menu && !menu.hidden) { setMenu(false); var mb = $('[data-menu-open]'); if (mb) mb.focus(); }
      return;
    }
    if (e.key === 'Tab' && drawerIsOpen()) {
      var d = drawer();
      var focusable = $$('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])', d)
        .filter(function (el) { return el.offsetParent !== null; });
      if (!focusable.length) return;
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* Filtres et tri : envoi automatique du formulaire à chaque choix */
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el && el.matches && el.matches('[data-auto-submit]')) {
      var form = closest(el, 'form');
      if (form) form.submit();
    }
  });

  /* ------------------------------------------------------------------
     Fiche produit : ajout au panier par le formulaire
  ------------------------------------------------------------------ */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-product-form]')) return;
    // Les boutons de paiement express gèrent eux-mêmes leur envoi.
    if (e.submitter && e.submitter.getAttribute('name') === 'checkout') return;
    e.preventDefault();

    var btn = $('[data-add-button]', form);
    var msg = $('[data-form-msg]', form);
    var idInput = $('[data-variant-id]', form);
    if (!idInput || !idInput.value) return;
    if (btn && (btn.disabled || btn.classList.contains('loading'))) return;
    if (msg) msg.textContent = '';
    if (btn) btn.classList.add('loading');

    addToCart(idInput.value, 1)
      .then(afterAdd)
      .catch(function (err) { if (msg) msg.textContent = err.message; })
      .then(function () { if (btn) btn.classList.remove('loading'); });
  });

  /* ------------------------------------------------------------------
     Fiche produit : galerie
  ------------------------------------------------------------------ */
  function initGallery(root) {
    if (!root || root.__cocoonGallery) return;
    var track = $('[data-track]', root);
    if (!track) return;
    root.__cocoonGallery = true;

    var n = $$('.pdp-slide', track).length;
    var prev = $('[data-prev]', root);
    var next = $('[data-next]', root);
    var count = $('[data-count]', root);
    var idx = 0;

    function go(i, instant) {
      i = Math.max(0, Math.min(n - 1, i));
      var left = i * track.clientWidth;
      if (track.scrollTo) track.scrollTo({ left: left, behavior: (instant || reduceMotion) ? 'auto' : 'smooth' });
      else track.scrollLeft = left;
    }

    function sync() {
      var i = track.clientWidth ? Math.max(0, Math.min(n - 1, Math.round(track.scrollLeft / track.clientWidth))) : 0;
      idx = i;
      $$('[data-thumb], [data-dot]', root).forEach(function (el) {
        el.setAttribute('aria-current', String(Number(el.getAttribute('data-index')) === i));
      });
      if (count) count.textContent = (i + 1) + ' / ' + n;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === n - 1;
    }

    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    root.addEventListener('click', function (e) {
      var t = e.target;
      var pick = closest(t, '[data-thumb], [data-dot]');
      if (pick) { go(Number(pick.getAttribute('data-index'))); return; }
      if (closest(t, '[data-prev]')) { go(idx - 1); return; }
      if (closest(t, '[data-next]')) { go(idx + 1); }
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { go(idx + 1); }
      else if (e.key === 'ArrowLeft') { go(idx - 1); }
    });
    window.addEventListener('resize', function () { go(idx, true); });

    root.__cocoonGo = go;
    var start = Number(root.getAttribute('data-initial-index')) || 0;
    if (start > 0) go(start, true);
    sync();
  }

  /* ------------------------------------------------------------------
     Fiche produit : variantes, prix, stock, barre fixe mobile
  ------------------------------------------------------------------ */
  function initProduct(section) {
    if (!section || section.__cocoonProduct) return;
    var form = $('[data-product-form]', section);
    if (!form) return;
    section.__cocoonProduct = true;

    var dataEl = $('[data-variants]', section);
    var variants = [];
    try { variants = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (err) { variants = []; }

    var fieldsets = $$('[data-option]', section).sort(function (a, b) {
      return Number(a.getAttribute('data-position')) - Number(b.getAttribute('data-position'));
    });
    var idInput = $('[data-variant-id]', form);
    var btn = $('[data-add-button]', form);
    var label = $('[data-add-label]', form);
    var priceEl = $('[data-price]', section);
    var badge = $('[data-badge]', section);
    var gallery = $('[data-gallery]', section);
    var msg = $('[data-form-msg]', form);
    var stockEl = $('[data-stock]', section);
    var deliveryEl = $('[data-delivery]', section);
    var stickyBar = $('[data-sticky-add]', section);
    var stickyBtn = stickyBar && $('[data-sticky-btn]', stickyBar);
    var stickyPrice = stickyBar && $('[data-sticky-price]', stickyBar);
    var notifyEl = $('[data-notify]', section);
    var notifyBody = notifyEl && $('[data-notify-body]', notifyEl);

    function selected() {
      return fieldsets.map(function (fs) {
        var c = $('input:checked', fs);
        return c ? c.value : null;
      });
    }

    function find(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }

    function markAvailability() {
      var current = selected();
      fieldsets.forEach(function (fs, pos) {
        $$('input', fs).forEach(function (input) {
          var test = current.slice();
          test[pos] = input.value;
          var any = variants.some(function (v) {
            return v.available && v.options.every(function (o, k) { return k === pos ? o === input.value : o === test[k]; });
          });
          input.classList.toggle('is-unavailable', !any);
        });
      });
    }

    function renderPrice(v) {
      if (!priceEl) return;
      priceEl.textContent = '';
      var now = document.createElement('span');
      now.className = 'p-now';
      now.textContent = v.price;
      priceEl.appendChild(now);
      if (v.compare) {
        var was = document.createElement('s');
        was.className = 'p-was';
        was.textContent = v.compare;
        priceEl.appendChild(was);
        if (v.saving) {
          var off = document.createElement('span');
          off.className = 'p-off';
          off.textContent = '−' + v.saving;
          priceEl.appendChild(off);
        }
      }
    }

    function renderStock(v) {
      if (!stockEl) return;
      var threshold = Number(stockEl.getAttribute('data-threshold')) || 0;
      if (threshold > 0 && v && v.stock && v.stock <= threshold) {
        stockEl.textContent = 'Plus que ' + v.stock + ' en stock';
        stockEl.hidden = false;
      } else {
        stockEl.textContent = '';
        stockEl.hidden = true;
      }
    }

    function renderNotify(v, opts) {
      if (!notifyEl || notifyEl.hasAttribute('data-posted')) return;
      notifyEl.hidden = !v || v.available;
      if (notifyBody && v) {
        var name = notifyEl.getAttribute('data-notify-product') || document.title;
        var picked = opts.filter(Boolean).join(' / ');
        notifyBody.value = '[Alerte retour en stock] ' + name + (picked ? ' (' + picked + ')' : '') +
          ' : prévenez-moi dès que ce produit est de nouveau disponible.';
      }
    }

    function update() {
      var opts = selected();
      fieldsets.forEach(function (fs, i) {
        var out = $('[data-option-value]', fs);
        if (out) out.textContent = opts[i] || '';
      });
      var v = find(opts);
      if (msg) msg.textContent = '';
      markAvailability();

      if (!v) {
        if (btn) btn.disabled = true;
        if (label) label.textContent = 'Indisponible';
        if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = 'Indisponible'; }
        renderStock(null);
        renderNotify(null, opts);
        return;
      }
      if (idInput) idInput.value = v.id;
      renderPrice(v);
      renderStock(v);
      if (btn) btn.disabled = !v.available;
      if (label) label.textContent = v.available ? 'Ajouter au panier · ' + v.price : 'Épuisé';
      if (deliveryEl) deliveryEl.hidden = !v.available;
      renderNotify(v, opts);
      if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = v.available ? 'Ajouter au panier' : 'Épuisé'; }
      if (stickyPrice) stickyPrice.textContent = v.price;

      if (badge && badge.hasAttribute('data-auto-badge')) {
        var bt = $('[data-badge-text]', badge);
        if (v.saving) { if (bt) bt.textContent = 'Économisez ' + v.saving; badge.hidden = false; }
        else { badge.hidden = true; }
      }

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      if (gallery && gallery.__cocoonGo && v.image > 0) gallery.__cocoonGo(v.image - 1);
    }

    section.addEventListener('change', function (e) {
      if (closest(e.target, '[data-option]')) update();
    });
    markAvailability();

    /* Barre fixe mobile : visible quand le bouton principal est sorti de l'écran par le haut */
    if (stickyBar && btn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var gone = !en.isIntersecting && en.boundingClientRect.top < 0;
          stickyBar.classList.toggle('is-on', gone);
          if (stickyBtn) stickyBtn.tabIndex = gone ? 0 : -1;
        });
      }, { threshold: 0 });
      io.observe(btn);
    }
  }

  /* ------------------------------------------------------------------
     Carrousel d'avis
  ------------------------------------------------------------------ */
  function initCarousel(root) {
    if (!root || root.__cocoonCarousel) return;
    var track = $('[data-cr-track]', root);
    if (!track) return;
    root.__cocoonCarousel = true;

    var prev = $('[data-cr-prev]', root);
    var next = $('[data-cr-next]', root);
    var dots = $('[data-cr-dots]', root);
    var cards = $$('.cr-card', track);

    function step() {
      var c = cards[0];
      if (!c) return track.clientWidth;
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      return c.getBoundingClientRect().width + gap;
    }

    function perView() {
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      return Math.max(1, Math.floor((track.clientWidth + gap) / step() + 0.02));
    }

    function scrollByCards(dir) {
      var amount = perView() * step() * dir;
      if (track.scrollBy) track.scrollBy({ left: amount, behavior: reduceMotion ? 'auto' : 'smooth' });
      else track.scrollLeft += amount;
    }

    function buildDots() {
      if (!dots) return;
      dots.textContent = '';
      var per = perView();
      var pages = Math.max(1, Math.ceil(cards.length / per));
      dots.hidden = pages < 2;
      for (var i = 0; i < pages; i++) {
        var d = document.createElement('i');
        d.setAttribute('data-page', String(i));
        dots.appendChild(d);
      }
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      if (dots) {
        var kids = $$('i', dots);
        if (kids.length) {
          var ratio = max > 0 ? track.scrollLeft / max : 0;
          var cur = Math.round(ratio * (kids.length - 1));
          kids.forEach(function (k, i) { k.className = i === cur ? 'on' : ''; });
        }
      }
      var noScroll = max <= 2;
      var nav = $('.cr-nav', root);
      if (nav) nav.hidden = noScroll;
    }

    if (prev) prev.addEventListener('click', function () { scrollByCards(-1); });
    if (next) next.addEventListener('click', function () { scrollByCards(1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); scrollByCards(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); scrollByCards(-1); }
    });
    window.addEventListener('resize', function () { buildDots(); sync(); });
    buildDots();
    sync();
  }

  /* ------------------------------------------------------------------
     Barre d'annonce : défilement des messages
  ------------------------------------------------------------------ */
  function initRotator(root) {
    if (!root || root.__cocoonRotator) return;
    root.__cocoonRotator = true;
    var msgs = $$('.announce-msg', root);
    if (msgs.length < 2 || !root.hasAttribute('data-autoplay') || reduceMotion) return;
    var i = 0, timer = null;
    function show(n) {
      msgs.forEach(function (m, k) { m.classList.toggle('is-on', k === n); });
    }
    function start() { if (!timer) timer = window.setInterval(function () { i = (i + 1) % msgs.length; show(i); }, 5000); }
    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    start();
  }

  /* ------------------------------------------------------------------
     Produits en vedette : onglets par catégorie
  ------------------------------------------------------------------ */
  function initTabs(bar) {
    if (!bar || bar.__cocoonTabs) return;
    var sec = bar.closest('section');
    var grid = sec ? $('[data-fgrid]', sec) : null;
    if (!grid) return;
    bar.__cocoonTabs = true;
    bar.hidden = false;
    var buttons = $$('.ftab', bar);
    var cards = $$('.pc', grid);

    function apply(filter) {
      buttons.forEach(function (b) {
        var on = b.getAttribute('data-filter') === filter;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      cards.forEach(function (c) {
        var show = filter === '*' || c.getAttribute('data-type') === filter;
        if (show) c.removeAttribute('hidden'); else c.setAttribute('hidden', '');
      });
      var track = $('[data-scroll-track]', sec);
      if (track) {
        track.scrollLeft = 0;
        track.dispatchEvent(new CustomEvent('scroller:refresh'));
      }
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () { apply(b.getAttribute('data-filter')); });
    });
  }


  /* ------------------------------------------------------------------
     Rangées défilantes (produits en vedette, galerie clients) :
     flèches, barre de progression, défilement tactile natif
  ------------------------------------------------------------------ */
  function initScroller(wrap) {
    if (!wrap || wrap.__cocoonScroller) return;
    var track = $('[data-scroll-track]', wrap);
    if (!track) return;
    wrap.__cocoonScroller = true;
    var nav = $('[data-scroll-nav]', wrap);
    var prev = $('[data-scroll-prev]', wrap);
    var next = $('[data-scroll-next]', wrap);
    var bar = document.createElement('div');
    bar.className = 'scr-bar';
    bar.setAttribute('aria-hidden', 'true');
    bar.hidden = true;
    var thumb = document.createElement('i');
    bar.appendChild(thumb);
    track.parentNode.insertBefore(bar, track.nextSibling);
    var ticking = false;

    function update() {
      ticking = false;
      var max = track.scrollWidth - track.clientWidth;
      var can = max > 4;
      if (nav) nav.hidden = !can;
      bar.hidden = !can;
      if (!can) return;
      var w = Math.max(track.clientWidth / track.scrollWidth, 0.14);
      var p = Math.min(1, Math.max(0, track.scrollLeft / max));
      thumb.style.width = (w * 100) + '%';
      thumb.style.transform = 'translateX(' + (p * (1 - w) / w * 100) + '%)';
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    }
    function queue() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    function step(dir) {
      var first = null;
      for (var i = 0; i < track.children.length; i++) {
        if (!track.children[i].hidden) { first = track.children[i]; break; }
      }
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 16;
      var w = first ? first.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      var n = Math.max(1, Math.floor(track.clientWidth / w));
      track.scrollBy({ left: dir * w * n, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', queue, { passive: true });
    track.addEventListener('scroller:refresh', update);
    window.addEventListener('resize', queue);
    if (window.ResizeObserver) new ResizeObserver(queue).observe(track);
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
    });
    window.addEventListener('load', queue);
    update();
  }

  function initAll(root) {
    $$('[data-gallery]', root).forEach(initGallery);
    $$('[data-product-section]', root).forEach(initProduct);
    $$('[data-carousel]', root).forEach(initCarousel);
    $$('[data-ftabs]', root).forEach(initTabs);
    $$('[data-scroller]', root).forEach(initScroller);
    $$('[data-rotator]', root).forEach(initRotator);
  }

  function boot() { initAll(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Éditeur de thème : réactive les scripts quand une section est rechargée.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });
})();
